module.exports = __webpack_public_path__ + "static/media/A2_11.3d6825da.png";